import { render } from "./RegularNotification.vue?vue&type=template&id=8e6199ce&scoped=true&ts=true"
import script from "./RegularNotification.vue?vue&type=script&lang=ts"
export * from "./RegularNotification.vue?vue&type=script&lang=ts"

import "./RegularNotification_1.scss?vue&type=style&index=0&id=8e6199ce&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./RegularNotification.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/var/www/briskly/brskl/products/business/app.prod.new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e6199ce"]])

export default __exports__